import {
  KEY__CREDENTIAL__PRIMARY,
  KEY__CREDENTIAL__SECONDARY
} from '../../../dictionaries/Credential.dic';
import {
  Arr
} from '../../Array.lib';
import {
  NOT
} from '../../Boolean.lib';
import Core from '../../Core';
import Http from '../../Http';
import {
  Obj
} from '../../Object.lib';
import {
  trim
} from '../../String.lib';
import {
  COLLECTION__CREDENTIALS
} from '../BE/loopback.api';

export default async function replaceCredentialKeys(params) {
  // normalize and reorder keys
  params = Obj(params);
  params = {
    key: params.key,
    from: params.from,
    replyTo: params.replyTo,
    to: params.to,
    cc: params.cc,
    bcc: params.bcc,
    subject: params.subject,
    html: params.html,
    attachments: params.attachments,
    source: params.source,
    userId: params.userId,
    boxKey: params.boxKey,
    ...params
  };
  const emails = {};
  Arr(
    await Http.get(Core.getApi(COLLECTION__CREDENTIALS + '/config'))
  ).forEach(({ config }) => {
    emails[config.key] = config.email;
  });
  // No credential exists
  if (NOT(Object.keys(emails).length)) {
    throw new Error('No G-Suite credentials found');
  }
  // Credential does not exist
  // Use the primary credential key
  if (NOT(emails[params.key])
  ) {
    params.key = KEY__CREDENTIAL__PRIMARY;
  }
  // Required credential does not exist
  if (
    NOT(emails[params.key])
  ) {
    throw new Error(`No G-Suite ${params.key} found`);
  }
  params.from = emails[params.key];
  if (trim(params.replyTo).includes(KEY__CREDENTIAL__PRIMARY)) {
    params.replyTo = emails[KEY__CREDENTIAL__PRIMARY];
  }
  else if (trim(params.replyTo).includes(KEY__CREDENTIAL__SECONDARY)) {
    params.replyTo = emails[KEY__CREDENTIAL__SECONDARY];
  }
  return params;
}
